gradeSetup.classy.controller({
    name: 'SetAllModalController',
    inject: ['$scope', '$scope', 'authServiceFactory', 'RestService', 'InformationService', 'PutService', 'PostService',
        'PurgeService', 'ModelService', 'GradeSetupModelService', 'StandardModalCudFactory', '$modalInstance'],
    init: function()
    {
        this.$.$modalInstance = this.$modalInstance;
        this.$.allTuition = 0;
    },
    applyToAll: function(tuition)
    {
        for (var i = 0; i < this.GradeSetupModelService.data.length; i++) {
            this.GradeSetupModelService.data[i].tuition = Number(tuition);
        }
    }
});
